export const log = (val, type = "Default") => {
  console.count(`%c ********** ${type}`, 'background: #222; color: #bada55');
  console.log(val);
  console.log(`********** ${type} end`);
};
